import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container container">
        <Link to="/" className="navbar-logo">
          <img src="/assets/Logo.png" alt="West Drayton Body Works Logo" className="logo-image" />
        </Link>

        <div className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
            Home
          </Link>
          <Link to="/services" className="nav-link" onClick={() => setMenuOpen(false)}>
            Services
          </Link>
          <Link to="/shop" className="nav-link" onClick={() => setMenuOpen(false)}>
            Shop
          </Link>
          <Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>
            About
          </Link>
          <Link to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>
            Contact Us
          </Link>
          <Link to="/quote" className="nav-link nav-link-quote" onClick={() => setMenuOpen(false)}>
            Get Quote
          </Link>
          <Link to="/terms" className="nav-link nav-link-small" onClick={() => setMenuOpen(false)}>
            Terms
          </Link>
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          <span className={`bar ${menuOpen ? 'active' : ''}`}></span>
          <span className={`bar ${menuOpen ? 'active' : ''}`}></span>
          <span className={`bar ${menuOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
